import makeGetCategoryForURL from './makeGetCategoryForURL'

export default makeGetCategoryForURL
